// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__32DfB","content":"ManualTimeModal_content__auwTV"};